<span
  class="text-ellipsis editable-tag"
  contenteditable
  #input
  (focusout)="onFocusout($event)"
  (keydown.enter)="onEnter($event, input)"
>
  {{ value }}
</span>
